import { isOpenPartnerProductOrderItemsSaveModal } from "@/atoms/item/is-open-partner-product-order-items-save-modal";
import { isOpenMovePartnerQuotePageModal } from "@/atoms/quote/is-open-move-partner-quote-page-modal";
import { ButtonColor } from "@/common/enum/button-color";
import { PartnerQuotePath } from "@/common/enum/path";
import { Button, Modal } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { InboxFullOutlineIcon } from "../icon/InboxFullOutlineIcon";
import { Body16Regular } from "../typography/Body16Regular";

export const IsMovePartnerQuoteModal = () => {
  const navigate = useNavigate();
  const [isOpenModal, setIsOpenModal] = useRecoilState(
    isOpenMovePartnerQuotePageModal
  );
  const [items, setItems] = useRecoilState(
    isOpenPartnerProductOrderItemsSaveModal
  );

  const closeModal = () => {
    setIsOpenModal(undefined);
  };

  const handleSubmit = async () => {
    navigate(
      PartnerQuotePath.QUOTES_DETAIL.replace(":id", String(isOpenModal))
    );
    setItems([]);
    closeModal();
  };

  if (!isOpenModal) {
    return null;
  }

  return (
    <Modal size="md" show={true} onClose={closeModal}>
      <Modal.Header className="pt-[10px] px-[10px] h-[36px] border-none"></Modal.Header>
      <Modal.Body className="p-0">
        <div className="flex flex-col items-center box-border py-[20px] gap-[20px]">
          <div className="w-[42px] h-[42px] flex items-center justify-center">
            <InboxFullOutlineIcon size={35} />
          </div>
          <div className="flex flex-col items-center">
            <Body16Regular className="text-semantic-text-secondary">
              견적서 내역을 추가했습니다.
            </Body16Regular>
            <Body16Regular className="text-semantic-text-secondary">
              견적서 상세 내역 페이지로 이동할까요?
            </Body16Regular>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="pt-0 border-none">
        <div className="flex gap-[16px] items-center justify-center w-full">
          <Button
            size="sm"
            color={ButtonColor.TRANSPARENT_OUTLINE}
            onClick={closeModal}
          >
            취소하기
          </Button>
          <Button size="sm" color={ButtonColor.PRIMARY} onClick={handleSubmit}>
            이동하기
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
